module.exports = __webpack_public_path__ + "img/65_8.b7310c46.png";